
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ProfitCalculationType enum
 */
class ProfitCalculationType {
  /**
   * Initialize enum with a given value
   * @param {ProfitCalculationType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ProfitCalculationType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ProfitCalculationType}
   * @param {!ProfitCalculationType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ProfitCalculationType)) {
      throw new TypeError('Instance of ProfitCalculationType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ProfitCalculationType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ProfitCalculationType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ProfitCalculationType.SimpleMarketPrice.value) {
      return 'SimpleMarketPrice'
    }
    if (this.value === ProfitCalculationType.CFD.value) {
      return 'CFD'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ProfitCalculationType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ProfitCalculationType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ProfitCalculationType} Created enum
   */
  static fromObject (other) {
    return new ProfitCalculationType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ProfitCalculationType.SimpleMarketPrice = new ProfitCalculationType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ProfitCalculationType.CFD = new ProfitCalculationType(0 + 1)

export { ProfitCalculationType };

/**
 * Fast Binary Encoding ProfitCalculationType field model
 */
class FieldModelProfitCalculationType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelProfitCalculationType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelProfitCalculationType}
   * @param {ProfitCalculationType=} defaults Default value, defaults is new ProfitCalculationType()
   * @returns {!ProfitCalculationType} Result value
   */
  get (defaults = new ProfitCalculationType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ProfitCalculationType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelProfitCalculationType}
   * @param {!ProfitCalculationType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelProfitCalculationType };
